var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[(_vm.loading)?_c('dashboard-graph-loading'):_vm._e(),_vm._v(" "),_c('apexchart',{ref:"tagreport",attrs:{"type":"bar","height":"auto","width":"100%","options":_vm.options,"series":_vm.series}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d37abcb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/dashboard/TagReportGraph.vue
// module id = null
// module chunks = 